import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import { VrstaIzostanka } from './vrsta-izostanka';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-vrsta-izostanka-update',
  templateUrl: './vrsta-izostanka-update.component.html'
})
export class VrstaIzostankaUpdateComponent extends BaseUpdateComponent<VrstaIzostanka> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService,translateService)
   }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'VRSTAIZOSTANKA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(30), 'maxlength', 'VRSTAIZOSTANKA.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Oznaka", Validators.required, 'required', 'VRSTAIZOSTANKA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Oznaka", Validators.maxLength(5), 'maxlength', 'VRSTAIZOSTANKA.NAZIV.VALIDATION.MAXLENGTH');
  }

}
